import React, { useState, useEffect } from 'react';
import SoftSignIn from './soft-sign-in';
import { EtrAPIClient } from '../../../core/src/etr-wcs-api-client';
import ExternalSignIn from './../external-sign-in';
const etrAPIClient = new EtrAPIClient();

export default props => {
    const { children, loggedIn, onSessionStateChange = () => {}, pStoreID, ...rest } = props;
    const [isActiveSession, setIsActiveSession] = useState(null);

    useEffect(() => {
        if (!loggedIn && pStoreID == undefined) {
            return () => {};
        }
        etrAPIClient.person.isActiveSession().then(isActive => {
            if (isActive) {
                onSessionStateChange(true);
                setIsActiveSession(true);
            } else {
                onSessionStateChange(false);
                setIsActiveSession(false);
            }
        });
    }, [loggedIn]);

    if (pStoreID == undefined) {
        if (loggedIn && isActiveSession === null) {
            return null;
        }
        if (!loggedIn || isActiveSession) {
            return children;
        }
    } else {
        const softsignin = loggedIn && isActiveSession === false;
        return (
            <>
                <ExternalSignIn softsignin={softsignin} />
                {children}
            </>
        );
    }

    return <SoftSignIn {...rest} />;
};
